export function formatNumber(nStr) {
  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1,$2");
  }
  return x1 + x2;
}

let arr = ["bob", "mary", "doug", "mary"];

const changeArr = (item, operator) => {
  if (operator === "+") return [...arr, item];

  if (operator === "-") {
    arr.splice(arr.indexOf(item), 1);
    return arr;
  }
};
